var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 49,
    viewBox: "0 0 25 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.785673 25.9439H6.12527V47.9261C6.12527 48.3601 6.47693 48.7117 6.91094 48.7117H15.9644C16.3984 48.7117 16.7501 48.3601 16.7501 47.9261V26.0474H22.8884C23.2875 26.0474 23.6233 25.7479 23.6689 25.3515L24.6012 17.2587C24.6268 17.0361 24.5562 16.8131 24.4073 16.6461C24.2581 16.4789 24.0447 16.3832 23.8208 16.3832H16.7504V11.3102C16.7504 9.781 17.5738 9.00554 19.1979 9.00554C19.4294 9.00554 23.8208 9.00554 23.8208 9.00554C24.2548 9.00554 24.6065 8.65372 24.6065 8.21987V0.791487C24.6065 0.357481 24.2548 0.00581398 23.8208 0.00581398H17.4498C17.4049 0.0036141 17.3051 0 17.158 0C16.0526 0 12.2101 0.217003 9.17494 3.00929C5.81194 6.10358 6.27942 9.8085 6.39114 10.4509V16.383H0.785673C0.351667 16.383 0 16.7347 0 17.1687V25.158C0 25.5921 0.351667 25.9439 0.785673 25.9439Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebookIcon.4254b09751512deacf9daf5036451e49.svg";
export { ForwardRef as ReactComponent };